import React from "react";
import { AiFillInstagram, AiOutlineWhatsApp } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { RiGithubLine } from "react-icons/ri";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const Contact = () => {
  const { ref, inView } = useInView({ threshold: 0.1 });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={inView && { opacity: 1 }}
      transition={{
        type: "keyframes",
        duration: window.matchMedia("(max-width: 850px)").matches ? 0.3 : 1.5,
        bounce: 1,
        delay: window.matchMedia("(max-width: 850px)").matches ? 0 : 0.2,
      }}
      className="Contact mt-5 text-light"
    >
      <div className="h-relative mx-auto">
        <h1 className="fw-bold Section-heading">Get In Touch</h1>
      </div>
      <div className="form w-75 mx-auto mt-4">
        <div>
          <label>Name:</label>
          <input
            type={"text"}
            className="form-control mt-1"
            placeholder="Your name"
          />
        </div>
        <div className="mt-3">
          <label>Email:</label>
          <input
            type={"email"}
            className="form-control mt-1"
            placeholder="test@gmail.com"
          />
        </div>
        <div className="mt-3">
          <label>Message:</label>
          <textarea
            className="form-control mt-1"
            placeholder="Your Message goes here"
          ></textarea>
        </div>
        <button className="cta-btn mt-4 px-3 py-2">Send Message</button>
      </div>
      <p className="text-center mt-3 fs-5">OR</p>
      <div className="d-flex justify-content-center mt-2">
        <a
          href="https://wa.me/03445059989"
          target={"_blank"}
          className="icon text-white"
        >
          <AiOutlineWhatsApp size={22} />
        </a>
        <a
          target={"_blank"}
          href="https://www.linkedin.com/in/muhammad-hasnainn/"
          className="text-white icon ms-3"
        >
          <FaLinkedinIn size={22} />
        </a>
        <a
          href="https://github.com/Muhammadhasnainn"
          target={"_blank"}
          className="text-white icon ms-3"
        >
          <RiGithubLine size={22} />
        </a>
        <a
          href="https://www.instagram.com/i_m_haxnain/"
          target={"_blank"}
          className="icon ms-3 text-white"
        >
          <AiFillInstagram size={22} />
        </a>
      </div>
    </motion.div>
  );
};

export default Contact;
